import React, { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import Actions from './components/Actions/Actions';
import Filter from './components/Filter/Filter';
import InfoList from './components/InfoList/InfoList';
import Information from './components/Information/Information';
import { InfoModalProvider } from './contexts/InfoModalContext';
import InfoModalForm from './components/InfoModalForm/InfoModalForm';
import useSetRefreshFn from '../../hooks/useSetRefreshFn';
import useFilterForQuery from './hooks/useFilterForQuery';
import { createInformationsKeys } from './queries/useInformations';
import { createInfoAttachmentListKey } from './queries/useInfoAttachmentList';
import { selectedInfoSelector } from './store/selectors';
import { createInfoBindKey } from './queries/useInfoBinds';
import { createInfoReactionsKeys } from './queries/useInfoReactions';
import { setSelectedInfo } from './store/actions';
import styles from './Informations.module.scss';

const Informations = () => {
  const queryClient = useQueryClient();
  const queryParams = useFilterForQuery();
  const dispatch = useDispatch();

  const info = useSelector(selectedInfoSelector);

  useSetRefreshFn(() => {
    const keys = [
      createInformationsKeys(queryParams),
      createInfoAttachmentListKey(info?.id),
      createInfoBindKey(info?.id),
      createInfoReactionsKeys(info?.id),
    ];

    if (info) {
      const data = queryClient.getQueryData(
        createInformationsKeys(queryParams)
      );
      const updatedInfo = data.find((item) => item.id === info.id);

      if (updatedInfo) {
        dispatch(setSelectedInfo(updatedInfo));
      }
    }

    keys.forEach((key) => {
      queryClient.invalidateQueries(key);
    });
  }, [queryParams, info?.id, queryClient]);

  useEffect(() => {
    dispatch(setSelectedInfo(null));
  }, [queryParams]);

  return (
    <InfoModalProvider>
      <Actions />
      <section className={styles.root}>
        <InfoList
          classname={cn(styles.col, styles.listCol)}
          queryParams={queryParams}
        />
        <Information className={cn(styles.col, styles.itemCol)} />
        <InfoModalForm />
        <Filter />
      </section>
    </InfoModalProvider>
  );
};

export default Informations;
